module.exports = "/lucky-balls/img/weager/balls/color/orange.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/color/orange.png
// module id = 1180
// module chunks = 0